import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";

const App = () => {
  return (
    <Routes>
      {/* Redirect root path to departments */}
      <Route path="/" element={<Navigate to="/auth/departments" replace />} />
      
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="rtl/*" element={<RtlLayout />} />
      
      {/* Catch all unknown routes and redirect to departments */}
      <Route path="*" element={<Navigate to="/auth/departments" replace />} />
    </Routes>
  );
};

export default App;
